
import { faCancel, faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { Alert, Button, Col, Container, Form, Row } from 'react-bootstrap';
import ModalComissoes from './ModalComissoes';
import { float2moeda } from '../../../../utils/Funcoes';
import ModalSimNao from '../../../../components/ModalSimNao';
import { ServicosService } from '../../../../services/api/Servicos/ServicosService';


const ServicosProfissionaisList = ({ profissionaisFields, handleRemoveConv, idServico, servico, fetchConv, remove, profModalAdd, setProfModalAdd }) => {

    const [showModal, setShowModal] = useState(false);
    const [profissionaisIdSelected, setProfissionalIdSelected] = useState(null);
    const [showDelete, setShowDelete] = useState(false)
    const [itemDelete, setItemDelete] = useState(null)
    const [alertMsg, setAlertMsg] = useState()

    const handleModalComissoes = (campo, index) => {
        setShowModal(true)
        setProfissionalIdSelected({
            id: campo.profissionaisId,
            nome: campo.nome,
        }
        )
    }
    const handleClose = async () => {
        setShowModal(false)
        setProfModalAdd(null)
    }
    console.log(profissionaisFields)


    const handleDesvinculaProfissional = (campo, index) => {
        setShowDelete(true)
        setItemDelete(index)
    }
    const handleDeleteItem = async () => {

        let idServicoProfissionais = profissionaisFields[itemDelete].idServicoProfissionais
        if (idServicoProfissionais != undefined) {
            let profissionaisExcluidosIds = [idServicoProfissionais]

            const data = await ServicosService.vincularProfissionais(idServico, {
                profissionaisExcluidosIds: profissionaisExcluidosIds
            });
            if (data.success) {
                setAlertMsg({
                    variant: 'success',
                    msg: 'Profissional desvinculado com sucesso!'
                })
            } else {
                setAlertMsg({
                    variant: 'danger',
                    msg: 'Ocorreu um erro ao desvincular o profissional!'
                })
            }

        } else {
            setAlertMsg({
                variant: 'success',
                msg: 'Profissional desvinculado com sucesso!'
            })
        }
        remove(itemDelete)
        setShowDelete(false)
        setTimeout(() => {
            setAlertMsg(null)
        }, 3000)

    }

    useEffect(() => {
        if (profModalAdd != null) {
            setShowModal(true)
            setProfissionalIdSelected(profModalAdd)
        }
    }, [profModalAdd])

    return (
        <>

            {(profissionaisFields.length == 0) ? <div className='alert alert-warning'>Nenhum profissional vinculado</div>


                : <>
                    
                        <div style={{
                            marginTop: '15px;', paddingBottom: '5px', borderBottom: '1px solid #dbdbdb', marginBottom: '3px !important',
                            alignItems: 'center'
                        }} className='d-none  d-md-flex'>


                            <Form.Group as={Col} controlId="" xs={12} md={3} className="text-left">
                                <Form.Label >Profissional</Form.Label>
                            </Form.Group>
                            <Form.Group as={Col} controlId="" xs={12} md={2} className="text-left">
                                <Form.Label >Possui Comissão?</Form.Label>
                            </Form.Group>
                            <Form.Group as={Col} controlId="" xs={12} md={2} className="text-left">
                                <Form.Label >Tipo de Comissão</Form.Label>
                            </Form.Group>
                            <Form.Group as={Col} controlId="" xs={12} md={2} className="text-left">
                                <Form.Label >Valor de Comissão</Form.Label>
                            </Form.Group>


                            {/*} <Form.Group as={Col} controlId="" xs={12} md={1} className="text-left">
                                          <Form.Label ></Form.Label>
                                      </Form.Group>*/}

                        </div>

                        {profissionaisFields?.map((campo, index) => (
                            <>


                                <Row style={{
                                    marginBottom: '1px !important', borderBottom: '1px solid #dbdbdb',
                                    background: 'aliceblue',
                                    paddingTop: '5px',
                                    paddingBottom: '5px'
                                }} >
                                    <Form.Group as={Col} controlId="" xs={6} sm={6} md={3} className="text-left mb-10">
                                        <Form.Label className='d-md-none d-flex'>Profissional: </Form.Label>
                                        {campo?.nome}
                                    </Form.Group>
                                    <Form.Group as={Col} controlId="" xs={6} sm={6} md={2} className="text-left mb-10">
                                        <Form.Label className='d-md-none d-flex'>Possui comissão? </Form.Label>
                                        {(campo?.possuiComissao == 1) ? <span className='text-success'>Sim</span> : <span className='text-danger'>Não</span>}
                                    </Form.Group>
                                    <Form.Group as={Col} controlId="" xs={6} sm={6} md={2} className="text-left mb-10">
                                        <Form.Label className='d-md-none d-flex'>Tipo de comissão: </Form.Label>
                                        {(campo?.tipoComissao == 1) ? 'Percentual' : 'Valor fixo'}
                                    </Form.Group>
                                    <Form.Group as={Col} controlId="" xs={6} sm={6} md={2} className="text-left mb-10">
                                        <Form.Label className='d-md-none d-flex'>Valor </Form.Label>
                                        {(campo?.tipoComissao == 1) ? float2moeda(campo?.valorComissao) + '%' : 'R$ ' + float2moeda(campo?.valorComissao)}
                                    </Form.Group>
                                    <Form.Group as={Col} xs={12} sm={12} md={2} className='text-right ' style={{
                                        display: 'flex',
                                        alignContent: 'center',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}>
                                        <Button variant='info' size='sm' title='Comissao' onClick={() => handleModalComissoes(campo, index)}><FontAwesomeIcon icon={faEdit} /> </Button>

                                        <Button variant='danger' size='sm' title='Desvincular profissional' className='ml-15' onClick={() => handleDesvinculaProfissional(campo, index)}><FontAwesomeIcon icon={faCancel} /></Button>

                                    </Form.Group>

                                </Row>
                                <hr className='d-md-none d-flex' style={{ border: 0, margin: '0.2rem 0' }} />
                            </>
                        ))
                        }
                        <br></br>
                        <Row   >
                            <Alert show={(alertMsg != null)} variant={alertMsg?.variant}
                                dismissible={true}
                                onClose={() => setAlertMsg(null)}

                            >{alertMsg?.msg}</Alert>
                        </Row>


                        <ModalSimNao
                            show={showDelete}
                            handleClose={() => { setShowDelete(false); setItemDelete(null) }}
                            handleConfirm={() => handleDeleteItem()}
                        >Desvincular este profissional do serviço?</ModalSimNao>

                        {(showModal) ? <ModalComissoes show={showModal}
                            fetchConv={fetchConv}
                            handleClose={handleClose}
                            idServico={idServico}
                            servico={servico}
                            profissionalSel={profissionaisIdSelected} 
                            setProfModalAdd={setProfModalAdd}
                            /> : ''
                        }
                </>
            }
        </>
    )

}

export default ServicosProfissionaisList; 